import { render } from "./amount.vue?vue&type=template&id=567c4728&scoped=true"
import script from "./amount.vue?vue&type=script&lang=js"
export * from "./amount.vue?vue&type=script&lang=js"

import "./amount.vue?vue&type=style&index=0&id=567c4728&lang=less&scoped=true"

import exportComponent from "/Users/aa/work/credit_chakra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567c4728"]])

export default __exports__